function Kicker({ children, dark = false }) {
  return (
    <p
      className={`mb-4 text-xs font-extrabold uppercase tracking-[0.22em] ${
        'text-gray-500'
      }`}
    >
      {children}
    </p>
  );
}

export default Kicker;
